import { DoctorAvatar } from '@/modules/JobListing/components/DoctorStories/components/DoctorAvatar/DoctorAvatar';
import { DoctorStory } from '@/modules/JobListing/utils/JobListingTypes';
import cx from 'classnames';

import styles from './DoctorStoryCard.module.scss';

export interface DoctorStoryCardProps {
  doctorStory: DoctorStory;
}

export const DoctorStoryCard = ({ doctorStory }: DoctorStoryCardProps) => {
  const { rating, quote, authorName, authorRole, grade, avatarImageUrl, tagLabel, tagVariant } =
    doctorStory;

  return (
    <article className={styles.card}>
      <div className={styles.stars} aria-label={`${rating} out of 5 stars`}>
        {Array.from({ length: rating }, (_, index) => (
          <span key={index}>★</span>
        ))}
      </div>
      <p className={styles.quote}>&ldquo;{quote}&rdquo;</p>
      <div className={styles.divider} />
      <div className={styles.doctorRow}>
        <DoctorAvatar grade={grade} avatarImageUrl={avatarImageUrl} />
        <div className={styles.nameBlock}>
          <p className={styles.authorName}>{authorName}</p>
          <p className={styles.authorRole}>{authorRole}</p>
        </div>
      </div>
      {/* CMS-sourced stories don't always have a category/subcategory tag to build a highlight
          pill from - only render one when there's actually a label to show. */}
      {tagLabel && (
        <span className={cx(styles.tag, tagVariant && styles[tagVariant])}>{tagLabel}</span>
      )}
    </article>
  );
};

export default DoctorStoryCard;
